var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYellowPartialCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 0c-5.5225 0-10 4.4775-10 10s4.4775 10 10 10 10-4.4775 10-10-4.4775-10-10-10zm.0253907 18.6653571v-17.33071424c4.7664286.01269535 8.6414286 3.89535714 8.6414286 8.66535714s-3.8746429 8.6525-8.6414286 8.6653571z",
    fill: "#dbac31",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYellowPartialCircle);
export default __webpack_public_path__ + "static/media/icon-yellow-partial-circle.ce1f6d4d.svg";
export { ForwardRef as ReactComponent };